var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOriginMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.77454,
    cy: 23.5,
    r: 5,
    fill: "white",
    stroke: "#1D2B36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6471 0C3.43059 0 3.05176e-05 3.58889 3.05176e-05 8.00002C3.05176e-05 9.32423 0.316502 10.6372 0.918126 11.8018L7.22892 23.7422C7.31293 23.9014 7.47303 24 7.6471 24C7.82118 24 7.98127 23.9014 8.06529 23.7422L14.3784 11.7978C14.9777 10.6372 15.2942 9.32419 15.2942 7.99997C15.2942 3.58889 11.8636 0 7.6471 0ZM7.6471 12C5.53885 12 3.82359 10.2056 3.82359 8.00002C3.82359 5.79445 5.53885 4.00003 7.6471 4.00003C9.75536 4.00003 11.4706 5.79445 11.4706 8.00002C11.4706 10.2056 9.75536 12 7.6471 12Z",
    fill: "#FF9801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginMarker);
export default __webpack_public_path__ + "static/media/origin-marker.eb6fc7666cb6b309b1ab9c2ea2b1d893.svg";
export { ForwardRef as ReactComponent };